// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".limitWidth[data-v-251ac7f2] {\n  min-height: 26px;\n  display: inline-block;\n  white-space: nowrap;\n  vertical-align: bottom;\n  margin-left: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
